var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Prop } from 'vue-property-decorator';
import SelectFilter from '@/components/select-filter/SelectFilter';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import LoaderCard from '@/components/loader-card/LoaderCard';
import DataTable from '@/components/data-table/DataTable';
import { Level } from '@/models/Level';
import { Activity } from '@/models/Activity';
import ErrorHandler from '@/support/ErrorHandler';
let CreateRecessDialog = class CreateRecessDialog extends Vue {
    constructor() {
        super(...arguments);
        this.visibility = {
            checkboxes: false,
        };
        this.clearSelects = false;
        this.currentStep = 1;
        this.selectedLevels = [];
    }
    mounted() {
        //
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    create() {
        const payload = this.createPayload();
        new Activity(payload)
            .create()
            .then((activity) => {
            this.currentStep = 3;
            this.$emit('activityCreated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    close() {
        this.$emit('input', false);
        this.$emit('userCreated');
        this.clearSelects = false;
        this.currentStep = 1;
    }
    clear() {
        this.clearSelects = true;
        this.$nextTick(() => {
            this.close();
        });
    }
    initialize() {
        //
    }
    createOrUpdate() {
        if (this.activity) {
            this.update();
        }
        else {
            this.create();
        }
    }
    createPayload() {
        if (!this.timeslot) {
            return {};
        }
        const payload = {
            timeslots: Array.isArray(this.timeslot) ? this.timeslot.map((timeslot) => timeslot.id) : [this.timeslot.id],
            type: 'recess',
            levels: this.selectedLevels.map((level) => {
                return {
                    id: level.id,
                    is_mandatory: true,
                };
            }),
        };
        return payload;
    }
    update() {
        const payload = this.createPayload();
        this.activity
            .put(payload)
            .then(() => {
            this.currentStep = 3;
            this.$emit('activityUpdated');
        });
    }
    get tableOptionsLevels() {
        return {
            name: {
                singular: this.$tc('level.title', 1),
                plural: this.$tc('level.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Level(),
        };
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], CreateRecessDialog.prototype, "timeslot", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_b = typeof Activity !== "undefined" && Activity) === "function" ? _b : Object)
], CreateRecessDialog.prototype, "activity", void 0);
CreateRecessDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
            SelectFilter,
            LoaderCard,
            DataTable,
        },
    })
], CreateRecessDialog);
export default CreateRecessDialog;
